import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=1dd66b5f&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=1dd66b5f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd66b5f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1dd66b5f')) {
      api.createRecord('1dd66b5f', component.options)
    } else {
      api.reload('1dd66b5f', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=1dd66b5f&scoped=true&", function () {
      api.rerender('1dd66b5f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2vH07teKVUaqW/JS/comp/GuestBox.vue"
export default component.exports